var _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAuthFooterDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.246145,
    y: 0.663246,
    width: 13.206,
    height: 13.3021,
    transform: "matrix(0.908751 0.417338 -0.416462 0.909153 7.38901 -0.0424718)",
    fill: "#C7DFF2",
    stroke: "#413D45"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.18945,
    width: 15.1344,
    height: 19.4369,
    fill: "white",
    stroke: "#413D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45327 22.0339C5.87269 22.0345 5.30728 21.8518 4.84033 21.5127V24.7396L6.45377 23.7644L8.06721 24.7396V21.5127C7.60002 21.852 7.0342 22.0348 6.45327 22.0339Z",
    fill: "white",
    stroke: "#413D45",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4542 22.05C7.93933 22.05 9.14326 20.8461 9.14326 19.3609C9.14326 17.8758 7.93933 16.6719 6.4542 16.6719C4.96907 16.6719 3.76514 17.8758 3.76514 19.3609C3.76514 20.8461 4.96907 22.05 6.4542 22.05Z",
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 6.99121,
    width: 10.2184,
    height: 1.07563,
    rx: 0.537813,
    fill: "#413D45"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 9.68066,
    width: 10.2184,
    height: 1.07563,
    rx: 0.537813,
    fill: "#413D45"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3.22656,
    y: 12.3701,
    width: 5.91594,
    height: 1.07563,
    rx: 0.537813,
    fill: "#413D45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuthFooterDoc);
export default __webpack_public_path__ + "static/media/icon_auth_footer_doc.6caee9a13bf5a0a751cae64967a104d5.svg";
export { ForwardRef as ReactComponent };